import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import { AuthService } from '@service/auth.service';
import {
  CreateOrderRatingsRequest,
  GetOrderRatingsRequest,
  GetOrderRatingsResponse,
  ListRatingsRequest,
  ListRatingsResponse,
} from '@proto/store/api/store/orders/ratings';

import { map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RatingRepositoryService {
  constructor(
    private http: LativHttpClient,
    private authService: AuthService
  ) {}

  listRatings(req: ListRatingsRequest): Observable<ListRatingsResponse> {
    return this.http
      .get(`v1/comments/${req.productId ? `${encodeURIComponent(req.productId)}` : ''}`, {
        params: ListRatingsRequest.toJSON(req) as {
          [param: string]: string;
        },
      })
      .pipe(map(res => ListRatingsResponse.fromJSON(res)));
  }

  getOrderRatings(req: GetOrderRatingsRequest): Observable<GetOrderRatingsResponse> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(
        switchMap(() =>
          this.http
            .get(`v1/comments/orders/${encodeURIComponent(req.orderId)}`)
            .pipe(map(res => GetOrderRatingsResponse.fromJSON(res)))
        )
      );
  }

  createOrderRatings(req: CreateOrderRatingsRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.post('v1/comments/orders:add', CreateOrderRatingsRequest.toJSON(req))));
  }
}
